import { Avatar, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CustomizedLetterAvatar from "../../../components/Custom/CustomizedLetterAvatar";
import CustomizedStatus from "../../../components/Custom/CustomizedStatus";
import AgGrid from "../../../components/Table/AgGrid";
import { getGoodIssueTab } from "../../../features/Purchase/PurchaseReturn/purchase-return-actions";
import { purchaseReturnActions } from "../../../features/Purchase/PurchaseReturn/purchase-return-slice";
import {
  dateComparator,
  filterParamsOptions,
} from "../../../utils/filterparams";

const GoodIssueTab = () => {
  const navigate = useNavigate();
  const gridRef = useRef();
  const dispatch = useDispatch();
  const { goodIssueTab } = useSelector((state) => state.purchaseReturn);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getGoodIssueTab(id, enqueueSnackbar));
    }
    return () => dispatch(purchaseReturnActions.resetGoodIssueTab());
  }, [dispatch, enqueueSnackbar, id]);

  const columnDefs = [
    {
      field: "created_date",
      headerName: t("inventory.documentDate"),
      filter: "agDateColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("date"),
        comparator: dateComparator,
      },
    },
    {
      field: "document_date",
      headerName: t("inventory.issue.issueDate"),
      filter: "agDateColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("date"),
        comparator: dateComparator,
      },
    },
    {
      field: "document_id",
      headerName: t("inventory.issue.documentId"),
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("string"),
      },
    },
    {
      field: "reference_document_id",
      headerName: t("inventory.referenceNo"),
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("string"),
      },
    },
    {
      field: "source_warehouse.thai_name",
      headerName: t("inventory.warehouse"),
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("string"),
      },
    },
    {
      field: "type",
      headerName: t("inventory.issue.issueType"),
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: filterParamsOptions("string"),
      },
    },
    {
      field: "created_by",
      headerName: t("inventory.issue.exportedBy"),
      filter: false,
      floatingFilter: false,
      cellRenderer: (params) => {
        if (params.value.img_url) {
          return <Avatar alt="img_url" src={params.value.img_url} />;
        } else {
          return (
            <CustomizedLetterAvatar
              name={params.value.first_name + " " + params.value.last_name}
            />
          );
        }
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "remark",
      headerName: t("inventory.remark"),
      filter: "agTextColumnFilter",
    },
    {
      field: "status",
      headerName: t("inventory.status"),
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["draft", "finished", "cancelled"],
        valueFormatter: (params) => {
          if (params.value === "draft") {
            return "ร่าง";
          }
          if (params.value === "finished") {
            return "เสร็จสิ้น";
          }
          return "ยกเลิก";
        },
      },
      cellRenderer: (params) => {
        return <CustomizedStatus status={params.data.status} />;
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  const onRowDoubleClicked = (params) => {
    navigate(`/inventory/issue/${params.data.document_id}`);
  };

  return (
    <>
      <Typography variant="h5" sx={{ ml: 1, mb: 4 }}>
        ใบ{t("inventory.issue.index")}
      </Typography>
      <AgGrid
        ref={gridRef}
        columnDefs={columnDefs}
        rowData={goodIssueTab}
        height={650}
        onRowDoubleClicked={onRowDoubleClicked}
      />
    </>
  );
};

export default GoodIssueTab;
